import { lazy } from 'react';

const TeamMembers = lazy(() => import('../../views/AppUser'));
const AppUserForm = lazy(() => import('../../views/AppUser/component/Form'));
const Department = lazy(() => import('../../views/Master/Department/index'));
const Designation = lazy(() => import('../../views/Master/Designation/index'));

const ProjectSetupRoute = [
    {
        path: '/project-team/department',
        element: <Department />
    },
    {
        path: '/project-team/designation',
        element: <Designation />
    },
    {
        path: '/project-team/team-members',
        element: <TeamMembers />
        // dbId: modules.setup_user
    },
    {
        path: '/project-team/team-members/add',
        element: <AppUserForm />
    },
    {
        path: '/project-team/team-members/edit/:id',
        element: <AppUserForm />
    }
];

export default ProjectSetupRoute;
